import {EventEmitter, Injectable} from '@angular/core';
import {HttpCommonService} from "./http-common.service";
import {Page} from "../models/page";

@Injectable()
export class SearchService {

  // 用于控制在高级检索页头部的搜索框不展示的发射和订阅
  public searchIsShow:EventEmitter<any> = new EventEmitter<any>();

  constructor(private httpService: HttpCommonService) {
  }

  private provinces = [];
  private industries = [];

  // 获取31个省市数据
  getProvinces(): any {
    return this.httpService.get("/enterprise/detail/xhsRest/common/getProvinces");
  }

  // 获取20个行业类别
  getIndustryCategory(): any {
    return this.httpService.get("/enterprise/detail/xhsRest/common/getIndustry");
  }

  getHistorySearch(): any {
    return this.httpService.get("/enterprise/detail/xhsRest/search/getSearchHistory");
  }

  getAdvanceSearch(params): any {
    return this.httpService.post("/enterprise/detail/xhsRest/search/companySearchByPage", params.conditions);
  }

  getEnterpriseList(page: Page): any {
    let enterList = [{'id': 1, 'name': '江苏未至科技股份有限公司0', 'legalPerson': '张子方', 'registMoney': '1000万', 'state': '续存'},
      {'id': 1, 'name': '江苏未至科技股份有限公司1', 'legalPerson': '张子方', 'registMoney': '1000万', 'state': '续存'},
      {'id': 2, 'name': '江苏未至科技股份有限公司2', 'legalPerson': '张子方', 'registMoney': '1000万', 'state': '续存'},
      {'id': 3, 'name': '江苏未至科技股份有限公司3', 'legalPerson': '张子方', 'registMoney': '1000万', 'state': '续存'},
      {'id': 4, 'name': '江苏未至科技股份有限公司4', 'legalPerson': '张子方', 'registMoney': '1000万', 'state': '续存'},
      {'id': 5, 'name': '江苏未至科技股份有限公司5', 'legalPerson': '张子方', 'registMoney': '1000万', 'state': '续存'},
      {'id': 6, 'name': '江苏未至科技股份有限公司6', 'legalPerson': '张子方', 'registMoney': '1000万', 'state': '续存'},
      {'id': 7, 'name': '江苏未至科技股份有限公司7', 'legalPerson': '张子方', 'registMoney': '1000万', 'state': '续存'},
      {'id': 1, 'name': '江苏未至科技股份有限公司8', 'legalPerson': '张子方', 'registMoney': '1000万', 'state': '续存'},
      {'id': 2, 'name': '江苏未至科技股份有限公司9', 'legalPerson': '张子方', 'registMoney': '1000万', 'state': '续存'},
      {'id': 3, 'name': '江苏未至科技股份有限公司10', 'legalPerson': '张子方', 'registMoney': '1000万', 'state': '续存'},
      {'id': 4, 'name': '江苏未至科技股份有限公司11', 'legalPerson': '张子方', 'registMoney': '1000万', 'state': '续存'},
      {'id': 5, 'name': '江苏未至科技股份有限公司12', 'legalPerson': '张子方', 'registMoney': '1000万', 'state': '续存'},
      {'id': 6, 'name': '江苏未至科技股份有限公司13', 'legalPerson': '张子方', 'registMoney': '1000万', 'state': '续存'},
      {'id': 7, 'name': '江苏未至科技股份有限公司14', 'legalPerson': '张子方', 'registMoney': '1000万', 'state': '续存'},
      {'id': 1, 'name': '江苏未至科技股份有限公司15', 'legalPerson': '张子方', 'registMoney': '1000万', 'state': '续存'},
      {'id': 2, 'name': '江苏未至科技股份有限公司16', 'legalPerson': '张子方', 'registMoney': '1000万', 'state': '续存'},
      {'id': 3, 'name': '江苏未至科技股份有限公司17', 'legalPerson': '张子方', 'registMoney': '1000万', 'state': '续存'},
      {'id': 4, 'name': '江苏未至科技股份有限公司18', 'legalPerson': '张子方', 'registMoney': '1000万', 'state': '续存'},
      {'id': 5, 'name': '江苏未至科技股份有限公司19', 'legalPerson': '张子方', 'registMoney': '1000万', 'state': '续存'},
      {'id': 6, 'name': '江苏未至科技股份有限公司20', 'legalPerson': '张子方', 'registMoney': '1000万', 'state': '续存'},
      {'id': 7, 'name': '江苏未至科技股份有限公司21', 'legalPerson': '张子方', 'registMoney': '1000万', 'state': '续存'}];
    let result = [];
    for (let i = 0; i < enterList.length; i++) {
      if (i >= (page.pageNo - 1) * page.pageSize && i < page.pageNo * page.pageSize) {
        result.push(enterList[i]);
      }
    }
    return {'totals': enterList.length, 'data': result};

  }

  /**
   * 导出数据
   * @param params
   */
  exportData(params): any{
    return this.httpService.locationUrl('/enterprise/detail/xhsRest/search/exportCompanyList', params.conditions);

  }
}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/services/search.service.ts